import { constants } from './constants.js';

export function getCommaSeparted(thelist) {
  if (thelist == undefined || thelist == null)
    return '';

  return thelist.map(x => x.name).join(", ");
}

export function getCommaSepartedStringsAsNoBr(thelist) {
  if (thelist == undefined || thelist == null)
    return '';

  return thelist.map(x => '<nobr>' + x + '</nobr>').join(", ");
}

export function getCommaSepartedStringsAsBr(thelist) {
  if (thelist == undefined || thelist == null)
    return '';

  return thelist.map(x => x + '<br/>').join(" ");
}

export function getCommaSepartedVariables(thelist) {
  if (thelist == undefined || thelist == null)
    return '';
  return thelist.map(x => x.variable.name).join(",");
}


export async function fetchJson(url, authorized) {
  const res = await fetch(constants.baseUrl + url);
  const json = await res.json();
  if (res.ok) {
    if (json.Error) {
      alert(json.Message)
      return;
    }
    return json;
  } else {
    if (authorized && !json.isLoggedIn) {
      alert('woops not logged in')
      showLoginScreen();

    }
    // alert('Mogelijk was je uitgelogd : an error happened in fetch json! \r\n' + url);
    // alert(JSON.stringify(json));
    // location.reload();
    // throw new Error(json);
  }
}


export function sortByField(prop) {
  return function (a, b) {
    if (a[prop] > b[prop])
      return 1;
    if (a[prop] < b[prop])
      return -1
    return 0
  }
}

export async function fetchJsonWithMethod(method, url, params) {
  try {
    const res = await fetch(constants.baseUrl + url, {
      method: method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(params)
    });
    var json = await res.json();
    if (json.Error) {
      alert(json.Message)
      return;
    }
    return json;

  } catch (s) {
    alert('Mogelijk was je uitgelogd : an error happened in fetch json with method! \r\n' + url + '\r\n' + s);
    alert(JSON.stringify(json));
    location.reload();

    throw new Error('an error happened posting data');

  }
}

export async function downloadFile(url, filename) {
  fetch(constants.baseUrl + url)
    .then(resp => {
      if (resp.status == 500) {
        alert('excel file not available');
        return;
      }
      resp.blob().then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
    })
    .catch((s) => {
      alert('Mogelijk was je uitgelogd : An error has happened in download file! \r\n' + url + '\r\n' + s)
    });
}